import { InjectionToken } from '@angular/core';

import { AuditModuleConfiguration } from './models/configuration';

export const AuditConfigurationService = new InjectionToken<AuditModuleConfiguration>('AuditModuleConfiguration');
